import React, { useState } from "react";
import {
  Accordion,
  Card,
  InputGroup,
  useAccordionButton,
} from "react-bootstrap";
import "../../stylesheets/animations.css";
import "../../stylesheets/home.css";

import { CSSTransition, SwitchTransition } from "react-transition-group";
import ImageCropper from "./ImageCropper";
import axios from "axios";
import { useEffect } from "react";
import HomeScanning from "./HomeScanning";
import { useParams } from "react-router-dom";
import HomeViewer from "./HomeViewer";
import DetailsForm from "./DetailsForm";
import { PageContext } from "../contexts/PageContext";


function PageSwitcher() {
  return (
    <div>
      <div></div>

      <div></div>
    </div>
  );
}

export default function Home({canGoNext, validation, submitFunction, id}) {
  const [page, setPage] = useState(1);
  const [croppedImages, setCroppedImages] = useState([null, null]);
  console.log(`page = ${page}`);
  return (
    <PageContext.Provider value={{ setPage, croppedImages, setCroppedImages }}>
      <div className="home">
        <div>
          <SwitchTransition>
            <CSSTransition
              key={page}
              addEndListener={(node, done) =>
                node.addEventListener("transitionend", done, false)
              }
              classNames="alert"
            >
              <div>
                {page == 1 ? (
                  <HomeScanning canGoNext={canGoNext}
                  />
                ) : (
                  // <HomeViewer />
                  <DetailsForm croppedImages={croppedImages} 
                  validation={validation}
                  submitFunction={submitFunction}
                  id={id}
                  />
                )}
              </div>
            </CSSTransition>
          </SwitchTransition>
        </div>
      </div>

      <PageSwitcher />
    </PageContext.Provider>
  );
}
